import { loadOptions } from '../formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '0', label: '0: Nac' },
			{ value: '1', label: '1: Imp Dir' },
			{ value: '2', label: '2: Imp Adq Int' },
			{ value: '3', label: '3: Nac c/Imp 40%-70%' },
			{ value: '4', label: '4: Nac c/Ajustes' },
			{ value: '5', label: '5: Nac c/Imp < 40%' },
			{ value: '6', label: '6: Imp Dir CAMEX' },
			{ value: '7', label: '7: Imp Adq Int CAMEX' },
			{ value: '8', label: '8: Nac c/Imp > 70%' }
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

